import React, { useContext, useEffect, useState } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import * as FaIcons from "react-icons/fa";
import "../../scss/pages/admin/_leloregistration.scss";
import leloContext from "../../context/leloreg/leloContext";
import { getsites, loadBrands } from "../findBrand";
import { Helmet } from "react-helmet-async";
import llacFav from "../../img/LLAC-favicon.ico";
import { getReactAppUrl } from "../../functions/getEnv";
import { toast } from "react-toastify";

const StudentCharterInformation = () => {
  const navigate = useNavigate();
  const { permalink, _uuid, _id, LeloRegistrationProfile } = useParams();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const charterQuery = queryParams.get("charter");
  const learningCenterQuery = queryParams.get("learningCenter");

  const VERSION = import.meta.env.VITE_VERSION;
  const reactAppUrl = getReactAppUrl(import.meta.env.VITE_NODE_ENV);

  useEffect(() => {
    const handleKeyPress = (event) => {
      // Check for Ctrl+Shift+V
      if (event.ctrlKey && event.shiftKey && event.key.toLowerCase() === "q") {
        toast.info(`🎮 Enrollments Version: ${VERSION}`);
      }
    };

    window.addEventListener("keydown", handleKeyPress);
    return () => {
      window.removeEventListener("keydown", handleKeyPress);
    };
  }, []);

  const {
    formData,
    onFormDataChange,
    getLeloDataUuid,
    leloDatauuid,
    getCoursesByPermalink,
    leloDatapermalink,
    getLeloSession,
    leloSession,
    getLeloSession1,
    leloSession1,
  } = useContext(leloContext);
  const { charter, charter_id, selectedLearningCenter, siteId, sesson_id } = formData || {};
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [searchSites, setSearchSites] = useState([]);
  const [brand, setBrand] = useState(null);

  const isFormFilled =
    charter?.trim() &&
    selectedLearningCenter?.trim() &&
    charter_id?.trim()

  useEffect(() => {
    const handleBeforeUnload = (event) => {
      const message = "Changes you made may not be saved.";
      event.returnValue = message;
    };
    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);
  
  useEffect(() => {
    if (_uuid) {
      getLeloDataUuid(_uuid)
    } else {
      getCoursesByPermalink(permalink)
    }
  }, [])

  useEffect(() => {
    if (permalink) {
      getLeloSession1(permalink);
    }
  }, [permalink]);
  
  // Add a check to log when leloSession1 data is available
  useEffect(() => {
    if (leloSession1?.data) {
       onFormDataChange({
        target: { name: "sesson_id", value: leloSession1.data[0]?._id || "" }
       });
    } 
  }, [leloSession1]);
// useEffect(() => {
  //   getLeloSession(_id || LeloRegistrationProfile)
  // }, [_id, LeloRegistrationProfile]);
  useEffect(() => {
    if (leloDatauuid?.data) {
      const site = leloDatauuid.data;

      onFormDataChange({
        target: { name: "charter_id", value: site.charter_id || "" },
      });
      onFormDataChange({
        target: { name: "charter", value: site.charter || "" },
      });
      onFormDataChange({
        target: {
          name: "selectedLearningCenter",
          value: site.learningCenters || "",
        },
      });
      onFormDataChange({
        target: {
          name: "siteId",
          value: site.siteId || "",
        },
      });
      onFormDataChange({
        target: {
          name: "sesson_id",
          value: site.LeloRegistrationProfile || "",
        },
      });
    }
  }, [leloDatauuid]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    onFormDataChange({ target: { name, value } });
  };

  const handleProgressClick = () => {
    setIsSubmitted(true);
    if (isFormFilled) {
      navigate("/leloStudent", { state: { permalink, _uuid, _id, LeloRegistrationProfile:sesson_id } });
    }
  };

  const getUniqueCharters = (sites) => {
    const seen = new Set();
    return sites.filter((site) => {
      if (seen.has(site.charter_name)) return false;
      seen.add(site.charter_name);
      return true;
    });
  };

  const getUniqueLearningCenters = (charterName) => {
    // First, filter sites by charter name
    const charterSites = searchSites.filter((site) => site.charter_name === charterName);

    // Create a map to store unique learning centers by siteId
    const uniqueLearningCentersMap = new Map();

    // Add each site to the map, using siteId as the key
    charterSites.forEach(site => {
      uniqueLearningCentersMap.set(site.siteId, {
        learningCenterName: site.learningCenterName,
        siteId: site.siteId
      });
    });

    // Convert the map values to an array
    return Array.from(uniqueLearningCentersMap.values());
  };

  const handleCharterChange = (e) => {
    const selectedCharter = e.target.value;
    const selectedCharterData = searchSites.filter(
      (site) => site.charter_name === selectedCharter
    );

    const centers = selectedCharterData.map((site) => site.learningCenterName);
    const siteId = selectedCharterData.length > 0 ? selectedCharterData[0].siteId : "";
    const leloRegistrationProfile = searchSites.length > 0 ? searchSites[0].LeloRegistrationProfile : "";

    const selectedCharterId =
      selectedCharterData.length > 0 ? selectedCharterData[0].charter_id : "";
    onFormDataChange({ target: { name: "charter", value: selectedCharter } });
    onFormDataChange({ target: { name: "learningCenter", value: centers } });
    onFormDataChange({ target: { name: "selectedLearningCenter", value: "" } });
    onFormDataChange({ target: { name: "charter_id", value: selectedCharterId } });
    onFormDataChange({ target: { name: "siteId", value: siteId } });
    onFormDataChange({ target: { name: "sesson_id", value: leloRegistrationProfile } });
  };

  const handleLearningCenterChange = (e) => {
    const selectedValue = e.target.value;
    // Find the selected site by matching both learningCenterName and siteId
    const selectedSite = searchSites.find(
      (site) => `${site.learningCenterName}|${site.siteId}` === selectedValue
    );

    if (selectedSite) {
      onFormDataChange({ target: { name: "selectedLearningCenter", value: selectedSite.learningCenterName } });
      onFormDataChange({ target: { name: "learningCenters", value: selectedSite.learningCenterName || "" } });
      onFormDataChange({ target: { name: "name", value: selectedSite.learningCenterName || "" } });
      onFormDataChange({ target: { name: "siteId", value: selectedSite.siteId || "" } });

    }
  };

  useEffect(() => {
    if (charterQuery && searchSites.length > 0) {
      const selectedCharterData = searchSites.filter(site => site.charter_name === charterQuery);
      const selectedCharterId = selectedCharterData.length > 0 ? selectedCharterData[0].charter_id : "";
      onFormDataChange({ target: { name: "charter", value: charterQuery } });
      onFormDataChange({ target: { name: "charter_id", value: selectedCharterId } });
    }

    if (learningCenterQuery && charterQuery && searchSites.length > 0) {
      const selectedCharterData = searchSites.filter(site => site.charter_name === charterQuery);
      const selectedSite = selectedCharterData.find(site => site.learningCenterName === learningCenterQuery);
      if (selectedSite) {
        onFormDataChange({ target: { name: "selectedLearningCenter", value: learningCenterQuery } });
        onFormDataChange({ target: { name: "siteId", value: selectedSite.siteId } });
        onFormDataChange({ target: { name: "sesson_id", value: selectedSite.LeloRegistrationProfile || "" } });
      }
    }
  }, [charterQuery, learningCenterQuery, searchSites]);

  // useEffect(() => {
  //   if (charterQuery && searchSites.length > 0) {
  //     const selectedCharterData = searchSites.filter(site => site.charter_name === charterQuery);
  //     const centers = [...new Set(selectedCharterData.map(site => site.learningCenterName))];
  //     const selectedCharterId = selectedCharterData.length > 0 ? [...new Set(selectedCharterData.map(item => item.charter_id))][0] : "";
  //     onFormDataChange({ target: { name: "charter", value: charterQuery } });
  //     onFormDataChange({ target: { name: "selectedLearningCenter", value: "" } });
  //     onFormDataChange({ target: { name: "charter_id", value: selectedCharterId } });
  //   }
  
  //   if (learningCenterQuery && charterQuery) {
  //     const selectedCharterData = searchSites.filter(site => site.charter_name === charterQuery);
  //     const centers = new Set(selectedCharterData.map(site => site.learningCenterName));
  //     if (centers.has(learningCenterQuery)) {
  //       const selectedSite = selectedCharterData.find(site => site.learningCenterName === learningCenterQuery);
  //       if (selectedSite) {
  //         onFormDataChange({ target: { name: "selectedLearningCenter", value: learningCenterQuery } });
  //         onFormDataChange({ target: { name: "name", value: selectedSite.learningCenterName } });
  //         onFormDataChange({ target: { name: "siteId", value: selectedSite.siteId } });
  //         onFormDataChange({ target: { name: "sesson_id", value: _id||LeloRegistrationProfile } });
  //       }
  //     }
  //   }
  // }, [_uuid, charterQuery, learningCenterQuery, searchSites]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (leloDatapermalink && leloDatapermalink.data) {
          const data = leloDatapermalink.data; 
          const filteredData = data
            .filter((site) => site.LeloRegistrationProfile === sesson_id)
            .map((site) => ({
              charter_name: site.charter_name,
              learningCenterName: site.learningCenterName,
              charter_id: site.charter_id,
              permalink: site.permalink,
              LeloRegistrationProfile: site.LeloRegistrationProfile,
              siteId: site.siteId,
            }));
          setSearchSites(filteredData);
        }
      } catch (error) {
        console.error("Error fetching charter and learning center data", error);
      }
    };
    if (_uuid === undefined) {
      fetchData();
    }
  }, [leloDatapermalink, permalink, _uuid, sesson_id]);

  useEffect(() => {
    const loadBrandData = async () => {
      await loadBrands();
      const brandName = getsites();
      setBrand(brandName);
    };

    loadBrandData();
  }, []);
  
  useEffect(() => {
    // Only check session expiration if leloSession1 data is available
    if (!leloSession1?.data) return;
    
    if(!_uuid) {
      if (leloSession1.data[0]?.status === "Inactive") {
        // window.location.href = `${reactAppUrl}/sessionExpired/${permalink}/${_id}`;        window.location.href = `${reactAppUrl}/sessionExpired/${permalink}`;
      } else if (
        leloSession1.data[0]?.status === "Active" &&
        (new Date(leloSession1.data[0].enrollmentStart) > new Date() ||
          new Date(leloSession1.data[0].enrollmentEnd) < new Date())
      ) {
        window.location.href = `${reactAppUrl}/sessionExpired/${permalink}`;
      }
    }
   else{
      if (leloSession1.data[0]?.status === "Inactive") {
        window.location.href = `${reactAppUrl}/sessionExpired/${permalink}/${_uuid}`;
      } else if (
        leloSession1.data[0]?.status === "Active" &&
        (new Date(leloSession1.data[0].enrollmentStart) > new Date() ||
          new Date(leloSession1.data[0].enrollmentEnd) < new Date())
      ) {
        window.location.href = `${reactAppUrl}/sessionExpired/${permalink}/${_uuid}`;
      }
   }

  }, [leloSession1, _uuid, permalink, LeloRegistrationProfile, _id]);

  
  if (_uuid === undefined) {

    return (
      <>
        <div className="item">
          <div className="session-title">
            {
              (() => {
                if (!leloSession1?.data) return "No courses available";

                const session = leloSession1.data.find(site => site._id === sesson_id)?.name
                  ?.replace(/(?<=\D)-/g, ' ')
                  ?.replace(/\b\w/g, char => char.toUpperCase());

                return session || "No courses available";
              })()
            }
          </div>

        </div>

        <div className="sub-form">
          <h2>
            Registration <span>(1/7)</span>
          </h2>

          <div className="charter-info">
            <h2>Location</h2>
            <div className="item">
              <div className="form-group">
                <div className="asterisk-group">
                  <h3 htmlFor="charter">Charter </h3>
                  <FaIcons.FaAsterisk className="asterisk-icon" />
                </div>
                <select
                  id="charter"
                  name="charter"
                  required
                  value={charter || ""}
                  onChange={handleCharterChange}
                  className={`${isSubmitted && !charter ? 'error' : ''}`}
                >
                  <option value="">Please Select</option>
                  {getUniqueCharters(searchSites).map((site) => (
                    <option key={site.charter_id} value={site.charter_name}>
                      {site.charter_name}
                    </option>
                  ))}
                </select>
                {brand === 'learn4life' ? (
                  <p className="info-text">
                    If you received a pre-filled link with the Charter and Learning
                    Center already selected, please contact the school before
                    changing. If you did not receive a pre-filled link and are unsure
                    of which charter and learning center to choose, please see our
                    site list at{" "}
                    <a
                      href="https://learn4life.org/locations"
                      target="_blank"
                      rel="noopener noreferrer">
                      https://learn4life.org/locations
                    </a>
                    .
                  </p>
                ) : (
                  <p></p>
                )}
              </div>
            </div>

            {/* Learning Center Dropdown */}
            <div className="item">
              <div className="asterisk-group">
                <h3 htmlFor="learningCenter">Learning Center</h3>
                <FaIcons.FaAsterisk className="asterisk-icon" />
              </div>
              <select
                id="learningCenter"
                name="selectedLearningCenter"
                required
                value={selectedLearningCenter && siteId ? `${selectedLearningCenter}|${siteId}` : ""}
                onChange={handleLearningCenterChange}
                disabled={!charter}
                className={`${isSubmitted && !selectedLearningCenter ? 'error' : ''}`}
              >
                <option value="">Please Select</option>
                {getUniqueLearningCenters(charter).map((center, index) => (
                  <option key={`${center.siteId}-${index}`} value={`${center.learningCenterName}|${center.siteId}`}>
                    {center.learningCenterName}
                  </option>
                ))}
              </select>
            </div>

          </div>

          {/* Progress Button */}
          <div className="progress-btns">
            <button className="circle-btn" onClick={handleProgressClick}>
              <FaIcons.FaChevronRight className="progress-level-btn" />
            </button>
          </div>
        </div>
      </>
    );
  }

  else {
    return (
      <>
        <Helmet>
          <meta charSet="utf-8" />
          <link rel="icon" type="image/x-icon" href={llacFav} />
        </Helmet>
        <div className="item">
          <div className="session-title">
            {
              (() => {
                if (!leloSession1?.data) return "No courses available";

                const session = leloSession1.data.find(site => site._id === sesson_id)?.name
                  ?.replace(/(?<=\D)-/g, ' ')
                  ?.replace(/\b\w/g, char => char.toUpperCase());

                return session || "No courses available";
              })()
            }
          </div>
        </div>

        <div className="sub-form">
          <h2>Registration</h2>

          {isSubmitted && !isFormFilled && (
            <p className="validation-msg">Please fill out the required fields</p>
          )}

          <div className="charter-info">
            <h2>Location</h2>

            <div className="form-group">
              <div className="asterisk-group">
                <label htmlFor="charter">Charter </label>
                <FaIcons.FaAsterisk className="asterisk-icon" />
              </div>

              <input
                type="text"
                id="charter"
                name="charter"
                disabled
                value={charter || ""}
                required
                onChange={handleChange}
                className={`${isSubmitted && !charter ? 'error' : ''}`}
              />
              <p className="info-text">
                If you received a pre-filled link with the Charter and Learning
                Center already selected, please contact the school before
                changing. If you did not receive a pre-filled link and are unsure
                of which charter and learning center to choose, please see our
                site list at{" "}
                <a
                  href="https://learn4life.org/locations"
                  target="_blank"
                  rel="noopener noreferrer">
                  https://learn4life.org/locations
                </a>
                .
              </p>
            </div>

            <div className="form-group">
              <div className="asterisk-group">
                <label htmlFor="learningCenter">Learning Center</label>
                <FaIcons.FaAsterisk className="asterisk-icon" />
              </div>

              <input
                type="text"
                id="learningCenters"
                name="selectedLearningCenter"
                value={selectedLearningCenter || ""}
                required
                disabled
                onChange={handleChange}
                className={`${isSubmitted && !selectedLearningCenter ? 'error' : ''}`}
              />
            </div>
          </div>

          <div className="progress-btns">
            <button className="circle-btn" onClick={handleProgressClick}>
              <FaIcons.FaChevronRight className="progress-level-btn" />
            </button>
          </div>
        </div>
      </>
    );
  }

};

export default StudentCharterInformation;